import { Injectable } from '@angular/core';
import {
    HttpClient
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GedScannerModel } from '../models/wks-entity.model';

export interface NautikoWSScanResult {
    success?: boolean;
    scanId?: string;
    filename?: string;
    scanner?: {
        id?: string;
        name?: string;
        manufacturer?: string;
        port?: string;
    };
}

export interface NautikoWSScanner {
    id: string;
    index?: number;
    manufacturer?: string;
    name?: string;
    port?: string;
}

@Injectable({
    providedIn: 'root'
})
export class NautikoWSScannerService {

    constructor(
        private httpClient: HttpClient
    ) {
    }

    /**
     * Vérification du service scanner.
     */
    health(
        scanner: GedScannerModel
    ): Observable<any> {

        const url =
            `${scanner.url}/api/health`;

        return this.httpClient.get<any>(
            url
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }

    /**
     * Numérisation d'un document.
     */
    scan(
        scanner: GedScannerModel,
        scannerId: string
            ): Observable<NautikoWSScanResult> {
        const url =
            `${scanner.url}/api/scanners/id/` +
            `${encodeURIComponent(scannerId)}/scan`;

        return this.httpClient.post<NautikoWSScanResult>(
            url,
            null
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }

    /**
     * Récupération du document numérisé.
     */
    getScan(
        scanner: GedScannerModel,
        scanId: string
    ): Observable<Blob> {

        const url =
            `${scanner.url}/api/scans/${scanId}`;

        return this.httpClient.get(
            url,
            {
                responseType: 'blob'
            }
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }
    /**
     * Suppression du document temporaire numérisé.
     */
    deleteScan(
        scanner: GedScannerModel,
        scanId: string
    ): Observable<any> {

        const url =
            `${scanner.url}/api/scans/${scanId}`;

        return this.httpClient.delete<any>(
            url
        ).pipe(
            catchError(this.handleErrorObservable)
        );
    }
    private handleErrorObservable(
        error: any
    ): Observable<never> {

        throw error;
    }

    getScanners(
    scanner: GedScannerModel
        ): Observable<NautikoWSScanner[]> {
        const url = `${scanner.url}/api/scanners`;

        return this.httpClient.get<NautikoWSScanner[]>(url).pipe(
            catchError(this.handleErrorObservable)
        );
    }
}
